import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_chip, {
    label: _ctx.count,
    size: _ctx.size,
    color: _ctx.color,
    "text-color": _ctx.textColor,
    outline: _ctx.outline,
    class: _normalizeClass([{'q-chip--soft': _ctx.outline}, "text-weight-bold"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tooltip, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label", "size", "color", "text-color", "outline", "class"])), [
    [_vShow, _ctx.count >= _ctx.min]
  ])
}